/**
 * Product Image Swiper Slider
 * Initializes Swiper sliders for product grid items
 */

(function() {
    'use strict';
  
    function initProductSliders() {
      const sliderContainers = document.querySelectorAll('.product-image-swiper-container');
      
      sliderContainers.forEach(container => {
        // Skip if already initialized
        if (container.swiper) return;
        
        // Initialize Swiper
        new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          navigation: {
            nextEl: container.querySelector('.product-slider-next'),
            prevEl: container.querySelector('.product-slider-prev'),
          },
          on: {
            init: function() {
              // Prevent clicks from bubbling to product link
              const arrows = container.querySelectorAll('.product-slider-prev, .product-slider-next');
              arrows.forEach(arrow => {
                arrow.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                });
              });
            }
          }
        });
      });
    }
  
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductSliders);
    } else {
      initProductSliders();
    }
  
    // Re-initialize when new products are loaded (for infinite scroll, AJAX, etc.)
    document.addEventListener('shopify:section:load', initProductSliders);
    
    // Also listen for custom events that might load new products
    document.addEventListener('DOMContentLoaded', function() {
      // MutationObserver to watch for dynamically added sliders
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            initProductSliders();
          }
        });
      });
  
      // Observe the main content area for changes
      const mainContent = document.querySelector('.main-content') || document.body;
      observer.observe(mainContent, {
        childList: true,
        subtree: true
      });
    });
  
  })();
  